import DocumentFileRegistrationDetail from "views/layout/DocumentFileRegistrationDetail";
import DocumentFileDeIdentification from "views/layout/DocumentFileDeIdentification";
import ImageFileDeIdentification from "views/layout/ImageFileDeIdentification";
import ImageFingerprintDeIdentification from "views/layout/ImageFingerprintDeIdentification";
import DocumentGraphVisualizationDetail from 'views/document/detail/DocumentGraphVisualizationDetail';

export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL 
//export const BACKEND_API_URL = ( window._env_ && window._env_.REACT_APP_BACKEND_API_URL ) || ""

export const VALID_LANGUAGES = ["ko", "en"]
export const DEFAULT_LANGUAGE = "ko"
export const DEFAULT_AUTOLOGOUT_MIN = "60"
export const MAX_LOGIN_ACCOUNT_HISTORY_COUNT = 5
export const MAX_LENGTH_ALLOWED_IPS = 128
export const MAX_LENGTH_USER_NAME = 64
export const MAX_LENGTH_DOMAIN_NAME = 64
export const MAX_LENGTH_COMPANY_NAME = 255
export const MAX_MAIL_GROUP_QUOTA = 51200
export const MAX_USER_ADD_QUOTA = 10240
export const MAX_COMPANY_MAIL_QUOTA = 51200

export const STORAGE_LANG_KEY = "admin_lang"
export const STORAGE_AUTH_TOKEN_KEY = "admin_access_token"
export const STORAGE_MY_EMAIL_ADDRESS_KEY = "admin_mail_addr"
export const STORAGE_MY_NAME_KEY = "admin_user_name"
export const STORAGE_MY_PICTURE_KEY = "admin_user_picture"
export const STORAGE_EXPIRES_AT_KEY = "admin_expires_at"
export const STORAGE_ACCOUNT_HISTORY_KEY = "admin_login_account_history"
export const STORAGE_AUTOLOGOUT_MIN_KEY = "admin_auto_logout_minutes"
export const STORAGE_COMPANY_ID = "admin_company_id"
export const STORAGE_ROLE_TYPE = "admin_role_type"

export const ROLE_TYPE_APPLICATION_ADMIN = "ROLE_SYSTEM"
export const ROLE_TYPE_COMPANY_ADMIN = "ROLE_ADMIN"
    
export const PATH_FOR_DOCUMENT_INDEX = "/document/list"
export const PATH_FOR_LOGIN = "/login"
export const PATH_FOR_LOGOUT = "/logout"

export const TOP_MENU_DOCUMENT = "document"

export const SIDEBAR_TYPE_DIVIDER = "divider"
export const SIDEBAR_TYPE_COLLAPSE = "collapse"
export const SIDEBAR_TYPE_ETC = "etc"

export const DOCUMENT_DEIDENTIFICATION_ROUTES = [{
    "id": "file.deIdentification",
    "path": "/document/file/deIdentification",
    component: DocumentFileDeIdentification,
    formName: "fileDeIdentificationForm",
    iconType: 'FindReplace'
},{
    "id": "image.deIdentification",
    "path": "/document/image/deIdentification",
    component: ImageFileDeIdentification,
    formName: "imageDeIdentificationForm",
    iconType: 'FindReplace'
},{
    "id": "image.fingerprint.deIdentification",
    "path": "/document/image/fingerprint/deIdentification",
    component: ImageFingerprintDeIdentification,
    formName: "imageFingerprintDeIdentificationForm",
    iconType: 'Fingerprint'
}]

export const DOCUMENT_REGISTRATION_ROUTES = [{
    "id": "file.registration",
    "path": "/document/file/registration",
    component: DocumentFileRegistrationDetail,
    formName: "fileRegistrationForm",
    iconType: 'Add'
}];

export const DOCUMENT_GRAPH_VISUALIZATION_ROUTES = [{
    "id": "graph.visualization",
    "path": "/document/graph/visualization",
    component: DocumentGraphVisualizationDetail,
    formName: "graphVisualizationForm",
    iconType: 'AccountTree'
}];

export const DOCUMENT_COMMON_ROUTES = DOCUMENT_REGISTRATION_ROUTES.concat(DOCUMENT_DEIDENTIFICATION_ROUTES);

export const LIST_INFO = {
    "document.file": {
        "PATH": "/document/list",
        "DEFAULT_SORTORDER": "date"
    },
}

export const HEADER_MENU_PREFIX = "HEADER_"
export const BADGE_MAX_NO = 999
export const QUOTA_VIOLATION_ACTION_DEFAULT = "RETURN"
export const QUOTA_VIOLATION_ACTION_RETURN = "RETURN"
export const QUOTA_VIOLATION_ACTION_STORE = "STORE"
export const QUOTA_WARNING_NOTIFICATION_DEFAULT = "ON"
export const QUOTA_WARNING_NOTIFICATION_ON = "ON"
export const QUOTA_WARNING_NOTIFICATION_OFF = "OFF"
export const ACCOUNT_STATUS_ENABLED = "ENABLED"
export const ACCOUNT_STATUS_DISABLED = "DISABLED"
export const ACCOUNT_STATUS_DORMANT = "DORMANT"

export const DATE_FORMAT_ALL = "YYYY-MM-DD hh:mm A"
export const DATE_FORMAT_ONLY_DATE = "YYYY-MM-DD"
export const DATE_FORMAT_ONLY_TIME = "hh:mm A"
export const DATE_FORMAT_MONTH_TIME = "MM-DD hh:mm A"

export const COLOR_LOGIN = "darkblue"
export const COLOR_SYSTEM = "darkblue"
export const COLOR_COMPANY = "darkblue"
export const COLOR_COMPANY_SELECT = "darkblue"
export const COLOR_MODAL_CONFIRM = "behance"
export const COLOR_MODAL_CANCEL = "cancel"
export const COLOR_MODAL_ETC = "etcBtn"

export const FILE_UPLOAD_MAX_SIZE = 20